export const UserURLs = {
    addView: '/users/add',
    editView: '/users/:id',
    listView: '/users'
}